import React from 'react'
import {
  Filters,
  FiltersProps,
  FilterInputProps,
  Select,
  PeriodDatePicker
} from '@src/containers/Visualisation/components'
import { ANALYTICS_NATIVE_THEME_CLASSIFIER_DATA } from '../constants'

import * as Styled from './Filters.styled'

const InputComponents: React.FC<FilterInputProps> = ({
  data,
  formValues,
  availableDateRange,
  isFetching,
  handleSelectChange,
  handleDateChange
}) => {
  return (
    <>
      <Select
        options={
          data?.category?.map(({ id, name }) => ({ value: id.toString(), label: name })) ?? []
        }
        value={formValues.category}
        isDisabled={isFetching}
        onChange={handleSelectChange}
        label="category"
        title={<>Категория бизнеса</>}
      />
      <Select
        options={
          data?.theme
            ?.filter(el => {
              return Number(el.category_id) === Number(formValues.category)
            })
            .map(({ id, name }) => ({ value: id.toString(), label: name })) ?? []
        }
        value={formValues.theme}
        isDisabled={isFetching}
        onChange={handleSelectChange}
        label="theme"
        title={<>Тематика бизнеса</>}
      />
      <Select
        options={data?.region?.map(({ id, name }) => ({ value: id.toString(), label: name })) ?? []}
        value={formValues.region}
        isDisabled={isFetching}
        label="region"
        onChange={handleSelectChange}
        title={<>Регион</>}
      />
      <PeriodDatePicker
        availableDateRange={availableDateRange}
        value={{
          min: formValues.min ? new Date(Number(formValues.min)) : undefined,
          max: formValues.max ? new Date(Number(formValues.max)) : undefined
        }}
        disabled={isFetching}
        onChange={handleDateChange}
      />
    </>
  )
}
const NativeAnalyticsFilters: React.FC<FiltersProps> = ({ data, isFetching, fetchData }) => {
  return (
    <Styled.Container
      as={Filters}
      data={data}
      isFetching={isFetching}
      fetchData={fetchData}
      themeClassifierModalData={ANALYTICS_NATIVE_THEME_CLASSIFIER_DATA}
      methodologyModalData={{
        period: (
          <>
            Инструмент анализирует данные с&nbsp;октября 2023 года и&nbsp;пополняет базу ежемесячно
          </>
        ),
        description: (
          <>
            Cервис аналитики Авито рассчитывает показатели, исходя из&nbsp;данных всех селлеров,
            представленных на&nbsp;платформе в&nbsp;указанных категориях в&nbsp;вертикалях
            &laquo;Товары&raquo; и&nbsp;&laquo;Услуги&raquo;.
            <br />
            <br />
            Вся информация предоставлена Авито.
          </>
        )
      }}
      FilterInputs={InputComponents}
    />
  )
}

export default NativeAnalyticsFilters
